import { PageContent } from '@reapitform/dashboard-ui'
import { elPy9, Table, TTableRowAction } from '@reapitform/common-ui'
import { emergencyContactTableConfig } from './emergency-contact-table-config'
import { useState } from 'react'
import { FlexContainer, TextBase } from '@reapit/elements'
import { useDefaultEmergencyContact } from '../../../../api/defaults/emergency-contact'
import { IDefaultEmergencyContact } from '../../../../api/types'
import { AddEmergencyContact } from './modal/add-emergency-contact'
import { UpdateEmergencyContactModal } from './modal/update-emergency-contact'
import { DeleteConfirmationModal } from './modal/delete-confirmation'
import { useSearchParams } from 'react-router-dom'

export const EmergencyContactTabContent: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState<boolean>(false)
  const [isOpenUpdateFormModal, setIsOpenUpdateFormModal] = useState<boolean>(false)
  const [isOpenAddFormModal, setIsOpenAddFormModal] = useState<boolean>(false)
  const [selectedData, setSelectedData] = useState<IDefaultEmergencyContact>()
  const { data, loading, errorString, updateCacheData } = useDefaultEmergencyContact({
    sortBy: searchParams.get('sortBy'),
    sortByDirection: searchParams.get('sortByDirection'),
  })

  const handleSortChanges = (key: string, order: 'asc' | 'desc') => {
    setSearchParams((params) => {
      params.set('sortBy', key)
      params.set('sortByDirection', order === 'asc' ? 'Ascending' : 'Descending')
      return params
    })
  }

  const rowActions: TTableRowAction<IDefaultEmergencyContact>[] = [
    {
      actionTitle: 'Edit',
      onClick: (data) => {
        setIsOpenUpdateFormModal(true)
        setSelectedData(data)
      },
    },
    {
      actionTitle: 'Delete',
      onClick: (data) => {
        setIsOpenDeleteConfirmation(true)
        setSelectedData(data)
      },
    },
  ]

  return (
    <PageContent className={elPy9}>
      <FlexContainer isFlexColumn>
        <TextBase hasSectionMargin>{emergencyContactTableConfig.description}</TextBase>
        <Table
          headers={emergencyContactTableConfig.header}
          rows={data}
          isLoading={loading}
          rowKeyIdentifier="id"
          errorMessage={errorString}
          emptyMessage={emergencyContactTableConfig.emptyMessages}
          tableDataCountMessage={emergencyContactTableConfig.countDisplay}
          onReorder={handleSortChanges}
          tableRowAction={rowActions}
          tableAction={{
            actionTitle: 'Add New',
            onClick: () => setIsOpenAddFormModal(true),
          }}
        />
      </FlexContainer>
      <AddEmergencyContact
        isOpen={isOpenAddFormModal}
        onOpenChange={(isOpen) => setIsOpenAddFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <UpdateEmergencyContactModal
        defaultValues={selectedData}
        isOpen={isOpenUpdateFormModal}
        onOpenChange={(isOpen) => setIsOpenUpdateFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <DeleteConfirmationModal
        data={selectedData}
        isOpen={isOpenDeleteConfirmation}
        onOpenChange={(isOpen) => setIsOpenDeleteConfirmation(isOpen)}
        refreshList={updateCacheData}
      />
    </PageContent>
  )
}
